/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  TerminateOwnTradingChallengeParticipationOptions,
  TerminateOwnTradingChallengeParticipationStatus200,
  TerminateOwnTradingChallengeParticipationStatus403,
  TerminateOwnTradingChallengeParticipationStatus404,
  TerminateOwnTradingChallengeParticipationStatus409,
  TerminateOwnTradingChallengeParticipationStatus500,
} from '../types/TerminateOwnTradingChallengeParticipation'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { terminateOwnTradingChallengeParticipation } from '../clients/terminateOwnTradingChallengeParticipation'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const terminateOwnTradingChallengeParticipationMutationKey = () =>
  [{ url: '/v1/trading_challenges/:trading_challenge_id/participants/self/terminate' }] as const

export function terminateOwnTradingChallengeParticipationMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = terminateOwnTradingChallengeParticipationMutationKey()
  return mutationOptions<
    TerminateOwnTradingChallengeParticipationStatus200,
    ResponseErrorConfig<
      | TerminateOwnTradingChallengeParticipationStatus403
      | TerminateOwnTradingChallengeParticipationStatus404
      | TerminateOwnTradingChallengeParticipationStatus409
      | TerminateOwnTradingChallengeParticipationStatus500
    >,
    TerminateOwnTradingChallengeParticipationOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return terminateOwnTradingChallengeParticipation({
        ...config,
        path,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Convenience alias that terminates the caller's own participation; redirects to /v1/trading_challenges/{trading_challenge_id}/participants/{user_id}/terminate. End a participant's run in a challenge before its own rules would: the participant leaves, or an operator removes them. No prize is paid, even to a participant who could have claimed one -- claim the prize first if that is what you want. The account is wound down, every remaining challenge credit is swept, and the participation is marked TERMINATED and frozen: from then on it takes no further daily snapshots and never appears in the results ranking again. The user is left deactivated with no challenge balance, and is free to register for another challenge. Participants may only terminate their own run; terminating someone else's requires admin, integrator (same tenant) or challenge manager (assigned challenge) rights.
 * @summary Leave a trading challenge
 * {@link /v1/trading_challenges/:trading_challenge_id/participants/self/terminate}
 */
export function useTerminateOwnTradingChallengeParticipation<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TerminateOwnTradingChallengeParticipationStatus200,
      ResponseErrorConfig<
        | TerminateOwnTradingChallengeParticipationStatus403
        | TerminateOwnTradingChallengeParticipationStatus404
        | TerminateOwnTradingChallengeParticipationStatus409
        | TerminateOwnTradingChallengeParticipationStatus500
      >,
      TerminateOwnTradingChallengeParticipationOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? terminateOwnTradingChallengeParticipationMutationKey()

  const baseOptions = terminateOwnTradingChallengeParticipationMutationOptions(
    config,
  ) as UseMutationOptions<
    TerminateOwnTradingChallengeParticipationStatus200,
    ResponseErrorConfig<
      | TerminateOwnTradingChallengeParticipationStatus403
      | TerminateOwnTradingChallengeParticipationStatus404
      | TerminateOwnTradingChallengeParticipationStatus409
      | TerminateOwnTradingChallengeParticipationStatus500
    >,
    TerminateOwnTradingChallengeParticipationOptions,
    TContext
  >

  return useMutation<
    TerminateOwnTradingChallengeParticipationStatus200,
    ResponseErrorConfig<
      | TerminateOwnTradingChallengeParticipationStatus403
      | TerminateOwnTradingChallengeParticipationStatus404
      | TerminateOwnTradingChallengeParticipationStatus409
      | TerminateOwnTradingChallengeParticipationStatus500
    >,
    TerminateOwnTradingChallengeParticipationOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    TerminateOwnTradingChallengeParticipationStatus200,
    ResponseErrorConfig<
      | TerminateOwnTradingChallengeParticipationStatus403
      | TerminateOwnTradingChallengeParticipationStatus404
      | TerminateOwnTradingChallengeParticipationStatus409
      | TerminateOwnTradingChallengeParticipationStatus500
    >,
    TerminateOwnTradingChallengeParticipationOptions,
    TContext
  >
}
